/**
 * **식별자를 짧게 보이기 — 규칙 하나**(D-119). 화면이 실행·작업·모델·사용자 id 를 줄여 보일 때(이름이 없는 기록의 라벨, 칩, 활동 로그의 소유자)
 * 이것 하나를 쓴다 — 전에는 실행 목록 카드가 12 자, 분석 화면·기록 패널·상호작용 화면·실행 로그·활동 로그가 저마다 `slice(0, 8)` 로 잘라 같은
 * 실행 id 가 화면마다 다른 길이로 보였다.
 *
 * - 평범한 id(UUID 등): 앞 8 자 — UUID 의 첫 묶음.
 * - `머리.꼬리` 꼴(세션 안의 작업처럼 앞이 문맥인 id): 머리 그대로 + `.` + 꼬리 앞 8 자.
 * 보이기만 한다 — 짧은 글로 무엇을 찾거나 견주지 않는다(겹칠 수 있다).
 */
const SHOWN = 8;

export function shortId(id: string): string {
  const [head, tail] = id.split('.');
  return tail ? `${head}.${tail.slice(0, SHOWN)}` : id.slice(0, SHOWN);
}
